import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const riskAnalyticsServices = {
  getRiskAnalyticsData,
  addNewRiskAnalytics,
  updateRiskAnalytics,
  softDeleteRestoreRiskAnalytics,
  deleteRiskAnalyticsData,
};

async function addNewRiskAnalytics(userData) {
  const response = await fetch(
    `${config.API_URL}addNewRiskAnalytics`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function updateRiskAnalytics(userData) {
  const response = await fetch(
    `${config.API_URL}updateRiskAnalytics`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function softDeleteRestoreRiskAnalytics(userData) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreRiskAnalytics`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function deleteRiskAnalyticsData(userData) {
  const response = await fetch(
    `${config.API_URL}deleteRiskAnalyticsData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function getRiskAnalyticsData(status = "all", searchData = "", page, length, extraQuery = {}) {
  const query = new URLSearchParams();
  query.append("search", searchData || "");

  if (page && length) {
    query.append("page", page);
    query.append("length", length);
  }

  Object.entries(extraQuery || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const response = await fetch(
    `${config.API_URL}getRiskAnalyticsData/${status}?${query.toString()}`,
    headersWithAuthWithoutBody("GET", headers)
  );

  const data = await response.json();
  return data;
}
